import { useParams } from 'react-router-dom'
import TranslationForm from './TranslationForm'

const View = () => {
    const params = useParams()

    return (
        <TranslationForm
            id={parseInt(params.translationId)}
            config={{
                submitSuccessMsg: {
                    header: 'Updated',
                    message: 'Translation updated successfully',
                },
                submitFailedMsg: {
                    header: 'Failed',
                    message: 'Failed to update translation',
                },
                saveButton: {
                    label: 'Update',
                    savingLabel: 'Updating translation...',
                },
            }}
        />
    )
}

export default View
